/**
 * Gets the collection offer from session storage
 * @returns {{ 
  *   collection?: { 
  *     url?: string, 
  *     id?: number, 
  *     handle?: string 
  *   }, 
  *   discount_code?: string, 
  *   min_items_count?: number, 
  *   exit_popup_id?: string
 * }} The collection offer object with default empty object
 */
export function getCollectionOffer() 
{
  const collectionOfferStr = sessionStorage.getItem('collectionOffer');

  if (collectionOfferStr) {
    try {
      return JSON.parse(collectionOfferStr);
    } catch {
      console.warn('Failed to parse collectionOffer from sessionStorage');
    }
  }

  return {};
}

/**
 * Custom element to show content based on collection offer presence
 */
class ShowOnCollectionOffer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
    window.addEventListener('DOMContentLoaded', this.render.bind(this));
    window.addEventListener('load', this.render.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('DOMContentLoaded', this.render.bind(this));
    window.removeEventListener('load', this.render.bind(this));
  }

  render()
  {
    const offer = getCollectionOffer();

    if (offer?.collection) {
      this.classList.remove('hidden');
    }    
  }
}

if(!customElements.get('show-on-collection-offer')) {
  customElements.define('show-on-collection-offer', ShowOnCollectionOffer);
}

/**
 * Custom element to hide content based on collection offer presence
 */
class HideOnCollectionOffer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
    window.addEventListener('DOMContentLoaded', this.render.bind(this));
    window.addEventListener('load', this.render.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('DOMContentLoaded', this.render.bind(this));
    window.removeEventListener('load', this.render.bind(this));
  }

  render()
  {
    const offer = getCollectionOffer();

    if (!offer?.collection) {
      this.classList.remove('hidden');
    }
  }
}

if(!customElements.get('hide-on-collection-offer')) {
  customElements.define('hide-on-collection-offer', HideOnCollectionOffer);
}

/**
 * Custom element for the offer collection link
 */
class OfferCollectionLink extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick.bind(this));
  }

  /* 
  Handles the click event to navigate to the collection offer page
  */
  handleClick()
  {
    const { collection } = getCollectionOffer();
    window.location.href = collection?.url || '/collections/all-products';
  }
}

if(!customElements.get('offer-collection-link')) {
  customElements.define('offer-collection-link', OfferCollectionLink);
}